import { IToastState } from "../reducers/toastReducer";

export const SHOW_TOAST = "SHOW_TOAST";

export const showToast = (value: IToastState) => {
  return { type: SHOW_TOAST, value };
};
